const filterButton = document.querySelector('.ao-package-wrapper .button-reset .reset')
let checker = (categories, pkg_types) => pkg_types.every(pkg_type => categories.includes(pkg_type))
const filterPackages = (pkg_types) => {
  document.querySelectorAll('.seatingChartPackage').forEach( (elem) => {
    let categories = elem.getAttribute('data-category-names').split(',')
    if(checker(categories, pkg_types)) {
      elem.classList.remove('hidden')
    }
  })
}

const filterGroups = () => {
  document.querySelectorAll('.group.group-packages').forEach( (group) => {
    let visiblePackages = group.querySelectorAll('.seatingChartPackage:not(.hidden)')
    let groupTable = group.querySelector('.ticket-table-head')
    if(visiblePackages.length == 0) {
      groupTable.classList.add('hidden')
      group.classList.add('hidden')
    } else {
      groupTable.classList.remove('hidden')
      group.classList.remove('hidden')
    }
  })
}

const enableDisableFiltersOptions = (dataFilters = []) => {
  Array.from(document.querySelectorAll('.options-wrapper .options .option')).forEach((option) => {
    option.classList.add('disabled')
  })

  Array.from(document.querySelectorAll('.options-wrapper .options .option')).forEach((option) => {
    let data_filter = option.getAttribute('data-filter')

    if(dataFilters.length == 0) {
      option.classList.remove('disabled')
    } else {
      if(dataFilters.includes(data_filter))
        option.classList.remove('disabled')
      else
        option.classList.add('disabled')
    }
  })
}

const enableDisableFilters = (data_categories = []) => {
  document.querySelectorAll('.secondary-filter-wrapper li[data-filter]').forEach( (elem) => {
    let pkg_type = elem.getAttribute('data-filter')

    if(data_categories.length == 0) {
      elem.classList.remove('disabled')
    } else {
      if(data_categories.includes(pkg_type))
        elem.classList.remove('disabled')
      else
        elem.classList.add('disabled')
    }
  })
}

const resetPackageType = () => {
  document.querySelectorAll('.seatingChartPackage').forEach( (elem) => {
    elem.classList.remove('hidden')
  })
}

const hideAllPackages = () => {
  document.querySelectorAll('.seatingChartPackage').forEach( (elem) => {
    elem.classList.add('hidden')
  })
}

const enableDisableResetButton = (data_categories = []) => {
  if(data_categories.length == 0) {
    if(filterButton)
      filterButton.setAttribute('disabled', '')
  } else {
    if(filterButton)
      filterButton.removeAttribute('disabled')
  }
}

const resetAll = () => {
  // reset packages
  resetPackageType()
  // reset option buttons
  document.querySelectorAll('.redesign-wrapper .options-wrapper .option').forEach( (option) => {
    option.classList.remove('disabled')
  })

  // reset group tables
  document.querySelectorAll('.group.group-packages').forEach( (group) => {
    let groupTable = group.querySelector('.ticket-table-head')
    group.classList.remove('hidden')
    groupTable.classList.remove('hidden')
  })

  // disable filter button
  if(filterButton)
    filterButton.setAttribute('disabled', '')

  // enable filter options
  enableDisableFilters()
  enableDisableFiltersOptions()
}


$(document).on('turbo:load', function () {
  $('.redesign-wrapper .options-wrapper .option').on('click', (e) => {
    e.preventDefault()
    let option = e.currentTarget

    if(!option.classList.contains('disabled')) {
      let pkg_type = e.target.dataset['filter']
      filterPackages([pkg_type])
      filterGroups()
    }
  })

  if(filterButton) {
    filterButton.addEventListener('click', (e) => {
      e.preventDefault()
      resetAll()
    })
  }
})

let pkg_types = []
$(document)
  .on('change', '.ao-package-wrapper input[type=checkbox]', function () {
    pkg_types = []
    let data_categories = []
    let elems = []

    elems = document.querySelectorAll('.secondary-filter-wrapper li[data-filter]')

    Array.from(elems).forEach( (elem) => {
      let pkg_type = elem.getAttribute('data-filter')

      if(pkg_type) {
        let isChecked = elem.querySelector('input[type=checkbox]').checked

        if(isChecked) {
          pkg_types.push(pkg_type)
        } else {
          let index = pkg_types.indexOf(pkg_type)
          if(index > 0) {
            pkg_types.splice(index, 1)
          }
        }
      }
      pkg_types = Array.from(new Set(pkg_types))
    })

    if (pkg_types.length == 0) {
      // updateAvailabilityCounter()
      resetAll()
    } else {
      hideAllPackages()
      filterPackages(pkg_types)
      document.querySelectorAll('.seatingChartPackage').forEach( (elem) => {
        if(!elem.classList.contains('hidden')) {
          let categories = elem.getAttribute('data-category-names').split(',')
          data_categories.push(categories)
        }
      })
      data_categories = data_categories.flat()
      data_categories = Array.from(new Set(data_categories))

      enableDisableFilters(data_categories)
      filterGroups()
      enableDisableFiltersOptions(data_categories)
      enableDisableResetButton(data_categories)
      // updateAvailabilityCounter()
    }
  })

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('.ao-package-wrapper .options-wrapper .option').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.preventDefault()
      let option = e.currentTarget

      if(!option.classList.contains('disabled')) {
        let pkg_type = e.target.dataset['filter']

        document.querySelectorAll('.secondary-filter-wrapper .dropdown-menu li').forEach((elem) => {
          if (elem.dataset['filter'] == pkg_type) {
            elem.querySelector('.switch input').click()
          }
        })
      }
    })
  })
})


